import { Component } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatListItem, MatNavList } from '@angular/material/list'
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav'
import { MatToolbarModule } from '@angular/material/toolbar'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { LayoutService } from '../../services/layout/layout.service'
import { CommonModule } from '@angular/common'
import { environment } from '../../../environments/environment'
import { MatExpansionModule } from '@angular/material/expansion'
import { CustomRoute } from '../../app.routes'

@Component({
    selector: 'app-side-menu',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatToolbarModule,
        MatSidenav,
        MatSidenavModule,
        MatNavList,
        MatListItem,
        RouterLink,
        MatExpansionModule,
        RouterLinkActive,
    ],
    templateUrl: './side-menu.component.html',
    styleUrl: './side-menu.component.css',
})
export class SideMenuComponent {
    isProd = environment.name
    isOpen = true
    showMenu = true
    routes: CustomRoute[] = []

    constructor(private layoutService: LayoutService) {}

    ngOnInit(): void {
        this.layoutService.navLinks$.subscribe((routes) => {
            this.routes = routes
        })
        this.layoutService.isOpen$.subscribe((open) => (this.isOpen = open))
        this.layoutService.showMenu$.subscribe((show) => (this.showMenu = show))
    }

    get mainRoutes(): CustomRoute[] {
        const allowedParents = ['incident', 'list-incident-madeja']

        return this.routes.filter(
            (r) =>
                r.data?.isModule === true &&
                r.data?.public === false &&
                allowedParents.includes(r.data?.parent ?? '')
        )
    }

    get moreRoutes(): CustomRoute[] {
        return this.routes.filter(
            (r) =>
                r.data?.isModule === true &&
                r.data?.public === false &&
                r.data?.parent === null &&
                !['home', 'colors'].includes(r.path!)
        )
    }

    get colorsRoute(): CustomRoute | null {
        if (this.isProd === 'prod') return null

        return (
            this.routes.find(
                (r) => r.path === 'colors' && r.data?.isModule === true
            ) ?? null
        )
    }

    resolveText(route: CustomRoute): string {
        return route.data?.menuText ?? route.path ?? ''
    }

    resolveIcon(route: CustomRoute): string {
        return route.data?.icon ?? 'chevron_right'
    }
}
